export default function PHP_ftp_rmdir() {
  return (
    <div>
      <h1>PHP_ftp_rmdir</h1>
    </div>
  );
}
